import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=5dc6bc9b&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=5dc6bc9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc6bc9b",
  null
  
)

export default component.exports